import axios from 'axios';
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BeatLoader } from 'react-spinners';
import GlobalFooter from './GlobalFooter';

function VerifyPhoneNumber() {
    const phone = localStorage.getItem("phone")
    const record = JSON.parse(localStorage.getItem("auth"));
    const [code, setCode] = useState('');  // State for input value
    const [isResent, setIsResent] = useState(false); // State to manage resend action
    const navigate = useNavigate()
    const [isLoading,setIsLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState(''); 

    const location = useLocation()

    const {payload} = location.state || {}


    const handleClose = ()=>{
        navigate("/pages/global-payment")
    }
    const handleSubmit = async(e)=>{
        e.preventDefault();
        setIsLoading(true);
         // Remove the dash before submitting
         const formattedCode = code.replace('-', '');  // Removing the dash
         const data ={
            otp:formattedCode,
            CustomerCode:payload.data.CustomerCode
        } 
        // console.log("payload: ",data)
         try{
            // const url = "https://1mgy6330f9.execute-api.us-east-2.amazonaws.com/production//verify-phone"
            const url = "https://1mgy6330f9.execute-api.us-east-2.amazonaws.com/production/verify-otp"
            const res = await axios.post(url,data)
            // console.log("response Data: ",res.data)
            setIsLoading(false)
            const result = res.data
            navigate('/pages/verify-success',{state:{data}})

         }catch(err){
            const expectedError = err?.response
            if(expectedError){
                const errorMessage = err?.response?.data?.message || "You’ve entered a wrong verification code, please retry."
                setErrorMessage(errorMessage);
            }else{
                setErrorMessage("Unable to verify code")
            }
            setIsLoading(false)
            console.log(err)
            // Clear error after 2 seconds
            setTimeout(() => {
                setErrorMessage('');
            }, 2000);
         }
        
       
    }
    // Handle input change and automatically format with a slash
    const handleInputChange = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, '');  // Remove any non-digit characters
        if (value.length > 3) {
            value = `${value.slice(0, 3)}-${value.slice(3, 6)}`;
        }
        setCode(value);
    };

    // Handle resend code
    const handleResend = () => {
        setIsResent(true); // Mark that code has been resent
        console.log('Code resent to +23481****2667');
        // Add logic to resend the token, e.g., call an API
        setTimeout(() => setIsResent(false), 3000);  // Reset after 3 seconds
    };

    function hashPhoneNumber(phoneNumber){
        // Assuming the number is a full Nigerian number without the +234
        const countryCode = '+234';  // Nigerian country code
        const firstPart = phoneNumber.slice(0, 2);  // Extract '81' or '80' for example
        const maskedPart = '****';  // Mask middle part
        const lastPart = phoneNumber.slice(-4);  // Last four digits
        
        // Combine to form the final output
        return `${countryCode}${firstPart}${maskedPart}${lastPart}`;
      }

    const isPhoneNumberEntered = code.trim().length >= 7;
  return (
    <div className='global_layout'>
        {/* {
                 record?.avatar ?
                 <div className='img_container'>
                     <img className='img_glob' src={record?.avatar} alt=''/>
                 </div>:
                <div className='glob_avater custom_avater'>
                    <p className='glob_avater_text'>{String(record?.data?.business_name).slice(0, 1)}</p>
                </div>
            } */}
    
    <div className='global_container'>
            <div className='top_bar'>
                <img src='/images/global/arrow-left.svg' alt='' onClick={handleClose}/>
                <img src='/images/global/close.svg' alt='' onClick={handleClose}/>
            </div>

            <div className='global_content'>
                <img style={{width:"54px",height:"60px"}} src='/images/global/verify.gif' alt='' />
                <p className='glob_title'>Very phone number</p>
                <p className='glob_desc'>We sent a verification code to {hashPhoneNumber(phone)}. Enter the verification code below:</p>
                
                
                {/* Phone Number */}
                <form className='glob_form' onSubmit={handleSubmit}>
                    <div className='phone_container'>
                        <div style={{display:"flex"}}>
                            <p className='glob_name'>Code</p>
                            <img src='/images/global/asterisk.svg' alt=''/>
                        </div>
                        {/* input field */}
                        <input 
                        className='inputValue' 
                        type='text'  
                       
                        placeholder='000-000' 
                        value={code} 
                        onChange={handleInputChange} 
                        maxLength="7"  // Limit input length to 6 digits plus the slash
                        required
                        />
                        {/* Error message */}
                        {errorMessage && (
                                <p className='error_msg' style={{ color: '#D92D20', marginTop: '5px' }}>{errorMessage}</p>
                        )}
                    </div>

                   

                    {/* <button className='btn unactive' style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"center",marginTop:"18px"}} >
                        <p>Proceed</p>
                        <img src='/images/global/inactive.svg' alt='' />
                    </button> */}

                    <button 
                     disabled={!isPhoneNumberEntered || isLoading}
                     className={`${!isPhoneNumberEntered || isLoading ? 'unactive' : 'globalBtn'}`}
                   
                    style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"center",marginTop:"18px",gap:"8px"}}
                    >
                        {isLoading ? (
                            <BeatLoader
                                color="#228985"
                                cssOverride={{}}
                            />              ) : (
                            <>   
                                <p>Proceed</p>
                                {
                                    !isPhoneNumberEntered || isLoading ?
                                    <img src='/images/global/inactive.svg' alt='' />:
                                    <img src='/images/global/activeArrow.svg' alt='' />
                                }
                            </>
                        )}   
                    </button>
                    <div className='resend_code' onClick={handleResend}>
                            <p style={{ color: "#1A6B68" }}>
                                {isResent ? 'Code resent!' : 'Resend code'}
                            </p>
                            <img src='/images/global/resendCode.svg' alt='' />
                    </div>
                </form>

            </div>
        </div>
        {
            !record?.total_whitelabelling &&
            <GlobalFooter />
        }
    </div>
  )
}

export default VerifyPhoneNumber